
import Vue from "vue";

const DeviceAPIService = class extends Vue {
  _DEBUG = false;

  constructor() {
    super();
    if (this._DEBUG) {
      this.debugMessage('BOOTSTRAPPED DEVICE API SERVICE');
    }
  }

  debugMessage(message) {
    if (this._DEBUG) {
      console.log(message);
    }
  }

  async getDevices(tenant, query = { limit: 30, skip: 0 }) {
    if (tenant && config) {   
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        const url = `${config.OPERATIONS_SERVICE}/tenants/${tenant}/devices?${new URLSearchParams(query).toString()}`;
        const request = new Request(url, {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
        });
        try {
            const response = await fetch(request);
            if (response.status === 403) {
              return;
            }
            if (response.status == 401) {
              return;
            }
            if (response.status == 503) {
              return this.fetchDevices(tenant, query);
            }
            if (response.status != 200) {
                return;
            } else {
              const data = await response.json();
              return data;
            }
        } catch (dex) {
            console.error("failed to get devices", dex);
        }
    }
  }

  async getBedsWithAttributes(tenant, query = { limit: 30, skip: 0 }, message = {}) {
    if (tenant && config) {   
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        const url = `${config.API_GATEWAY_APIGEE}/tenants/${tenant}/beds-attributes?${new URLSearchParams(query).toString()}`;
        const request = new Request(url, {
            method: "POST",
            mode: "cors",
            cache: "default",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(message),
        });
        try {
            const response = await fetch(request);
            if (response.status === 403) {
              return;
            }
            if (response.status == 401) {
              return;
            }
            if (response.status == 503) {
              return this.getBedsWithAttributes(tenant, query, message);
            }
            if (response.status != 200) {
                return;
            } else {
              const data = await response.json();
              return data;
            }
        } catch (dex) {
            console.error("failed to get devices", dex);
        }
    }
  }

  async getDeviceAttributes(tenant, deviceId) {
    if (tenant && config && deviceId) {   
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        const url = `${config.API_GATEWAY_APIGEE}/tenants/${tenant}/devices/${deviceId}/attributes/BED_PROPERTIES`;
        const request = new Request(url, {
            method: "GET",
            mode: "cors",
            cache: "default",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
        });
        try {
            const response = await fetch(request);
            if (response.status === 403) {
              return;
            }
            if (response.status == 401) {
              return;
            }
            if (response.status == 503) {
              return this.getDeviceAttributes(tenant, deviceId);
            }
            if (response.status != 200) {
                return;
            } else {
              const data = await response.json();
              return data;
            }
        } catch (dex) {
            console.error("failed to get devices", dex);
        }
    }
  }
};

// Singleton Pattern Instantiate
if (!Vue.prototype.$DeviceAPIService) {
  Vue.prototype.$DeviceAPIService = new DeviceAPIService();
}

export default Vue.prototype.$DeviceAPIService;
